<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <div>我的余额</div>
        <router-link class="record" :to="'/user/cashrecord'">
          提现记录<span class="iconfont icon-xiangyou"></span>
        </router-link>
      </div>
      <div class="num">{{ now_money || 0 }}</div>
      <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>昨日收益</div>
          <div class="money">{{ userInfo.yesterDay || 0 }}</div>
        </div>
        <div class="item">
          <div>累积已提</div>
          <div class="money">{{ userInfo.extractTotalPrice || 0 }}</div>
        </div>
      </div>
    </div>
    <div class="bnt bg-color-red" @click="toCash">立即提现</div>
    <div class="list acea-row row-between-wrapper">
		<div class="item acea-row row-center-wrapper row-column">
			<img style="width: 0.8rem;" src="../../../assets/images/touzi.png" >
			<div style="margin-top: 10px;" @click="futou">一键复投</div>
		</div>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/poster'"
      >
        <span class="iconfont icon-erweima"></span>
        <div>推广名片</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_list'"
      >
        <span class="iconfont icon-tongji"></span>
        <div>推广人统计</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission'"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>奖励记录</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_order'"
      >
        <span class="iconfont icon-dingdan"></span>
        <div>推广人订单</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_rank'"
      >
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission/rank'"
      >
        <span class="iconfont icon-paihang"></span>
        <div>奖励排行</div>
      </router-link>
    </div>
	<div class="popup" v-if="show==0">
		<div class="popup_p">
			<p class="">复投金额</p>
			<input class="" placeholder="请输入复投金额" v-model="jine"/>
			<button class="" @click="futoujine">提交</button>
		</div>
		<!-- <img style="width: 0.8rem;" src="../../../assets/images/touzi.png" > -->
		<img class="close" @click="closes" src="../../../assets/images/close.png" />
	</div>
  </div>
</template>
<script>
import { getUser,getBalance,getFutou } from "../../../api/user";

export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
		show:1,
      userInfo: {},
	  now_money: 0,
	  orderStatusSum: 0,
	  recharge: 0,
	  jine:'',
    };
  },
  watch: {
    $route(n) {
      if (n.name == "UserPromotion") this.getInfo();
    }
  },
  mounted: function() {
    this.getInfo();
	this.getIndex();
  },
  methods: {
    getInfo: function() {
      let that = this;
      getUser().then(
        res => {
          that.userInfo = res.data;
          console.log(that.userInfo);
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
	getIndex: function() {
		let that = this;
		getBalance().then(
			res => {
				that.now_money = res.data.now_money;
				that.orderStatusSum = res.data.price;
				that.recharge = res.data.integral;
			},
			err => {
				that.$dialog.message(err.msg);
			}
		);
	},
    toCash: function() {
      this.$router.push({ path: "/user/user_cash" });
    },
	closes:function(){
		this.show = 1
	},
	futou:function(){
		this.show=0
		
	},
	futoujine:function(){
		console.log(this.jine)
		if(this.jine%100==0){
			getFutou(
				{price:this.jine}
			).then(
				res=>{
					console.log(res)
					this.$dialog.message(res.msg);
					this.$router.push({ path: "/user" });
					this.show = 1
				},
			)
		}else{
			this.$dialog.message('复投数量需100或100的倍数');
		}
		
	}
  }
};
</script>
<style type="text/css">
	.popup{position: fixed;top:0;left:0;width:100%;height: 100vh;background-color: rgba(0,0,0,0.5);}
	.popup_p{background-color:rgba(0,0,0,0.8);width: 65%;margin: 0 auto;margin-top: 37%;border-radius: 10px;padding: 25px;}
	.popup_p p{font-size:20px;color:#ffffff;text-align: center;}
	.popup_p input{height: 40px;margin-top: 10px;font-size: 18px;color: #fff;margin-bottom: 10px;}
	.popup_p button{width: 52%;height: 40px;color:#FFFFFF;background-color: #CA1F10;margin: 0 auto;display: block;border-radius: 10px;}
	.close{position: absolute;left: 70%;top: 19%;width: 30px;}
</style>

